import { render, staticRenderFns } from "./MetricCompare.vue?vue&type=template&id=9a704d28&scoped=true"
import script from "./MetricCompare.vue?vue&type=script&lang=js"
export * from "./MetricCompare.vue?vue&type=script&lang=js"
import style0 from "./MetricCompare.vue?vue&type=style&index=0&id=9a704d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a704d28",
  null
  
)

export default component.exports